export default {
  多元活动连接全球市场: "Diverse Events Connecting Global Markets",
  共享全球顶级资源与学术支持:
    "Access top global resources and academic support to kickstart your trading journey with confidence.",
  了解更多: "Learn More",
  敬请期待: "Stay tuned",
  每个认真交易的人: "Exceptional Brilliant Care for Every Committed Trader",
  pageTitleH1: `Earn Up to <span class="red">18%</span> p.a. in Monthly Rewards `,
  pageTitleH2: "When Followers Copy Your Trades",
  activityListMetaData: [
    {
      label: "Market Activities",
      list: [
         {
          id: "2-12",
          img: require("@/assets/image/activityList/banner2_12.png?v=2.0.0"),
          bannerTitle: `<img
          class="img-logo"
          src="${require("@/assets/image/logo/logo_row_white_en.svg")}"
          alt="logo"
        />
        <div class="barca2526-title en">Trade to Win Barça Tickets – Experience Spotify Camp Nou Live</div>
        <img
          class="img-arrow"
          src="${require("@/assets/image/activityList/arrow.svg")}"
          alt=""
        />
        `,
          bannerBoxClass: "barca2526-title-box",
          bannerSubTitle: "",
          title: "Trade to Win Barça Tickets – Experience Spotify Camp Nou Live",
          subtitle:
            "Trade with the World’s Best* Broker, to win FC Barcelona home tickets with flights and hotel included, and witness Spotify Camp Nou's rebirth alongside football stars.",
          url: "/activityList/barca2526",
          time: "",
        },
        {
          id: "2-4",
          img: require("@/assets/image/activityList/banner2_4New.png"),
          bannerTitle: "Join the Fund Manager Growth Program",
          bannerSubTitle:
            'Up to <span class="red">18%</span>  p.a. monthly rewards',
          title: "Enjoy Monthly Payouts",
          subtitle:
            "The rewards are designed specifically for exceptional traders. Monthly rewards are based on the number of followers and total AUM, with reward rates reaching up to 18% per year.",
          url: "/pay",
          time: "",
        },
        {
          id: "2-3",
          img: require("@/assets/image/activityList/banner2_3.png"),
          bannerTitle: "Create. Earn.<br/> Get Paid.",
          bannerTitleClass: "creator-incentives-title",
          bannerSubTitle: "",
          bannerSubTitleClass: "creator-incentives-subtitle",
          title: "Creator Incentive Programme",
          subtitle:
            "Join our Creator Incentive Programme and turn your impact into income.",
          url: "/activityList/creator-incentives",
          time: "",
        },
        {
          id: "2-9",
          img: require("@/assets/image/activityList/banner2_9_en.png"),
          title: "Million Dollar Trading Challenge II Has Ended",
          subtitle: "Copy the Champion's Trades for Free",
          url: "/million-dollar-challenge-2",
          time: "",
        },
        // {
        //   id: "2-10",
        //   img: require("@/assets/image/activityList/messi_en.png"),
        //   title: "Trade with EBC & Win a Limited Edition Messi Signed Jersey",
        //   subtitle: "Event Period: 1 March 2025 - 31 March 2025",
        //   url: "/trade-for-messi",
        //   time: "",
        // },
        {
          id: "2-7",
          img: require("@/assets/image/activityList/banner2_7_en.png"),
          title:
            "EBC Partners with TradingView to Connect You to Global Markets",
          subtitle:
            "Limited-time Offer: Unlock TradingView Membership Benefits and Stay on Top of Global Market Trends in Real-time",
          url: "/TradingView",
          time: "",
        },

        {
          id: "2-1",
          img: require("@/assets/image/activityList/banner2_1_en.png"),
          title: "1 Million Trading Contest ",
          subtitle: "Win 1 Million: Searching for Trading King.",
          url: "/win1",
          time: "",
        },
      ],
    },
    {
      label: "Brand Updates",
      list: [
        {
          id: "3-5",
          img: require("@/assets/image/activityList/banner3_5_en.png"),
          title: "EBC Joins Money Expo Chile 2025",
          subtitle: `Visit the largest booth at Money Expo Chile for a truly rewarding experience! With exclusive FC Barcelona giveaways, surprise appearances, essential trading tips/insights and much more, we look forward to getting to know all of you from our trading community.   
Follow us on Facebook (@ EBC Financial LATAM) for the latest updates. `,
          url: "/activity/moneyexpochile2025/",
          time: "27–28 August 2025",
        },
        {
          id: "3-4",
          img: require("@/assets/image/activityList/banner3_4_en.png"),
          title: "EBC Shines as Diamond Sponsor at iFX EXPO LATAM 2025",
          subtitle:
            "EBC Financial Group participated as a Diamond Sponsor at iFX EXPO LATAM 2025, connecting with attendees at Booth 18. During the event, the team shared insights into how innovative financial services can empower investors to seize opportunities and manage risks amid the ongoing transformation of the global trade landscape.",
          url: "/LearningCenterInfo?id=LEARN-664-666",
          time: "9-10 April 2025",
        },
        {
          id: "3-3",
          img: require("@/assets/image/activityList/banner3_3_en.png"),
          title: "Highlights: EBC at Money Expo Mexico 2025",
          subtitle:
            "EBC proudly participated as a Platinum Sponsor at Money Expo Mexico 2025, connecting with industry experts. Together, we explored fintech innovations and emerging trading opportunities.",
          url: "/LearningCenterInfo?id=LEARN-782-60B",
          time: "26-27 February 2025",
        },
        {
          id: "3-1",
          img: require("@/assets/image/activityList/banner3_1_en.png"),
          title:
            "How to Use Climate Economics to Explore Trading Opportunities",
          subtitle: `"What Do Economists Actually Do?" A Timely Discussion on Driving Policy Improvements and Economic Growth with Economics.`,
          url: "/partners/oxford",
          time: "November 14, 2024",
        },
        {
          id: "3-2",
          img: require("@/assets/image/activityList/banner3_2_en.png"),
          title: "EBC & Oxford Collaboration for the Seminar",
          subtitle: `This Seminar will be held at Christ Church College, Oxford University, on 14 November 2024 at 14:30 (GMT), with live streaming available globally for all investors.`,
          url: "/partners/oxford",
          time: "March 6, 2024",
        },
      ],
    },
  ],
};
